import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NavController, ModalController, LoadingController, NavParams, IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { AcompanhamentoProvider } from "src/app/services/acompanhamento/acompanhamento";
import { CommonModule } from "@angular/common";

import { format, isBefore, isEqual } from "date-fns";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { ToastController } from "@ionic/angular/standalone";

@Component({
  selector: "app-acompanhamento-filtro",
  templateUrl: "./acompanhamento-filtro.page.html",
  styleUrls: ["./acompanhamento-filtro.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ProverDatepickerComponent,
    ReactiveFormsModule,
  ],
})
export class AcompanhamentoFiltroPage implements OnInit {
  validations_form: FormGroup;
  tipos: any = [];
  categoriaList: any = [{ id: "0", titulo: this.translate.instant("Todos") }];
  acaoList: any = [];
  filtro: any = {};
  dataInicio = format(new Date(), "yyyy-MM-dd");
  dataFim = format(new Date(), "yyyy-MM-dd");
  listTipos: any = [
    { id: "0", nome: this.translate.instant("Todos") },
    { id: "acompanhamento", nome: this.translate.instant("Acompanhamento") },
    { id: "compromisso", nome: this.translate.instant("Compromisso") },
  ];
  constructor(
    public navCtrl: NavController,
    private translate: TranslateService,
    public formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public acompanhamentoProvider: AcompanhamentoProvider,
    public navParams: NavParams,
    public toastCtrl: ToastController
  ) {
    this.filtro = this.navParams.get("filtro");
    this.dataInicio = this.filtro.dataInicio;
    this.dataFim = this.filtro.dataFim;

    this.acompanhamentoProvider.getDadosBasicos().subscribe((data) => {
      this.categoriaList = [{ id: "0", titulo: this.translate.instant("Todos")}, ...data.categorias];
      if (this.filtro.idCategoria) {
        this.changeAcao(this.filtro.idCategoria);
      }
    });
  }

  ngOnInit() {
    this.validations_form = this.formBuilder.group({
      dataInicio: new FormControl(this.filtro.dataInicio, Validators.nullValidator),
      dataFim: new FormControl(this.filtro.dataFim, Validators.nullValidator),
      tipo: new FormControl(this.filtro.tipo, Validators.nullValidator),
      idCategoria: new FormControl(this.filtro.idCategoria, Validators.nullValidator),
      idAcompanhamentoOperacao: new FormControl(this.filtro.idAcompanhamentoOperacao, Validators.nullValidator),
    });
  }

  changeAcao(categoria: any) {
    const idCategoria = categoria.detail ? categoria.detail.value : categoria;
    const acao = this.categoriaList.find((categoria: { id: string }) => categoria.id == idCategoria);
    this.acaoList = acao ? acao.acoes : [];

    if (!acao) {
      this.validations_form.get("idAcompanhamentoOperacao")?.setValue("0");
    }
  }

  async onSubmit(form: any) {
    const result =
      isBefore(new Date(form.dataInicio), new Date(form.dataFim)) ||
      isEqual(new Date(form.dataInicio), new Date(form.dataFim));

    if (!result) {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant("As datas informadas não atendem aos critérios de validação."),
        duration: 3000,
      });

      toast.present();
      return;
    }

    form.dataInicio = this.dataInicio;
    form.dataFim = this.dataFim;
    this.modalCtrl.dismiss(form);
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
